import {Controller} from '@hotwired/stimulus';

const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Bascule une liste entre son état vide et son contenu, y compris quand des éléments y sont ajoutés
 * ou retirés sans rechargement.
 *
 *   <div {{ stimulus_controller('list-empty-state') }}>
 *     <button {{ stimulus_target('list-empty-state', 'filled') }}>…</button>
 *     <ul {{ stimulus_target('list-empty-state', 'list') }}>…</ul>
 *     <div {{ stimulus_target('list-empty-state', 'empty') }} hidden>…</div>
 *   </div>
 *
 * Les targets `empty` (l'état vide) ne s'affichent que si `list` n'a aucun élément enfant, les
 * targets `filled` (le CTA d'en-tête que l'état vide remplace) que si elle en a. Le Twig rend l'état
 * initial (`hidden`). Si le focus était dans un bloc qui se masque, il passe au premier élément
 * focalisable des blocs qui s'affichent.
 */
export default class extends Controller {
  static targets = ['list', 'empty', 'filled'];

  connect() {
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this.listTarget, {childList: true});
    this.refresh();
  }

  disconnect() {
    this.observer.disconnect();
  }

  refresh() {
    const isEmpty = this.listTarget.children.length === 0;
    const shown = isEmpty ? this.emptyTargets : this.filledTargets;
    const hidden = isEmpty ? this.filledTargets : this.emptyTargets;
    const focusLost = hidden.some((element) => !element.hidden && element.contains(document.activeElement));

    shown.forEach((element) => {
      element.hidden = false;
    });
    hidden.forEach((element) => {
      element.hidden = true;
    });

    if (focusLost) {
      shown
        .map((element) => (element.matches(FOCUSABLE) ? element : element.querySelector(FOCUSABLE)))
        .find((element) => element !== null)
        ?.focus();
    }
  }
}
